import { DisplayExamDate, Loader, Error } from '../../common'
import { ProcessButton } from '../common/detail'
import ProcessApprovalRequestForm from '../../../containers/forms/ProcessApprovalRequestForm'
import { fetchApprovalRequestDetail } from '../../../actions/approvalRequests'
import {
  selectSelectedApprovalRequest,
  getApprovalRequestProcessing,
  selectApprovalRequestType,
} from '../../../selectors/approvalRequests'
import { APPROVAL_REQUEST_CONFIG } from '../../../constants/ApprovalRequestConstants'

const mapStateToProps = state => {
  const approvalRequest = selectSelectedApprovalRequest(state)

  return {
    approvalRequest,
    arType: selectApprovalRequestType(state),
    processingApprovalRequest: getApprovalRequestProcessing(state),
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchApprovalRequestDetail,
    },
    dispatch
  )

const dataBlockStyle = { marginBottom: '1em' }
const headerStyle = { fontFamily: 'Roboto,sans-serif', fontSize: '.9rem', fontWeight: 'bold' }
const valueStyle = { fontSize: '.875rem' }

class Request extends Component {
  componentDidMount() {
    const { approvalRequest, arType, fetchApprovalRequestDetail } = this.props
    const id = approvalRequest[APPROVAL_REQUEST_CONFIG[arType].idField]

    fetchApprovalRequestDetail(id, arType)
  }

  componentDidUpdate(prevProps) {
    const { approvalRequest, arType, fetchApprovalRequestDetail } = this.props
    const id = approvalRequest[APPROVAL_REQUEST_CONFIG[arType].idField]

    if (prevProps.approvalRequest[APPROVAL_REQUEST_CONFIG[arType].idField] !== id) {
      fetchApprovalRequestDetail(id, arType)
    }
  }

  render() {
    const {
      approvalRequest,
      approvalRequest: { aiCode, orgName, course, totalExams, fetching, error },
      processingApprovalRequest,
    } = this.props

    if (error) {
      return <Error message={error} />
    }

    if (fetching) {
      return <Loader />
    }

    return (
      <>
        <div className="row">
          <div className="col-xs-12" style={dataBlockStyle}>
            <h4 style={headerStyle}>School</h4>
            <div style={valueStyle}>
              {aiCode} <span style={{ marginLeft: '25px' }}>{orgName}</span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6 col-xs-12" style={dataBlockStyle}>
            <h4 style={headerStyle}>Course</h4>
            <div style={valueStyle}>{course}</div>
          </div>
          <div className="col-sm-6 col-xs-12" style={dataBlockStyle}>
            <h4 style={headerStyle}>Exam Date</h4>
            <span style={valueStyle}>
              <DisplayExamDate data={approvalRequest} />
            </span>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6 col-xs-12" style={dataBlockStyle}>
            <h4 style={headerStyle}>Quantity</h4>
            <div style={valueStyle}>{totalExams}</div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12" style={{ marginBottom: '1.5em' }}>
            {processingApprovalRequest ? <ProcessApprovalRequestForm /> : <ProcessButton />}
          </div>
        </div>
      </>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Request)
